import React from 'react';
import PropTypes from 'prop-types';

function IconButtonFeedback({ size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.49512 4V7.00468M8.49512 9.52612H8.50512M2.38889 1C1.62037 1 1 1.62963 1 2.39815V15L3.7963 12.1944H13.6019C14.3704 12.1944 15 11.5648 15 10.7963V2.39815C15 1.62963 14.3704 1 13.6019 1H2.38889Z" stroke="#141414" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
}

IconButtonFeedback.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconButtonFeedback;
